import { render, staticRenderFns } from "./park-holiday-rule2.vue?vue&type=template&id=6357c5ff&scoped=true&"
import script from "./park-holiday-rule2.vue?vue&type=script&lang=js&"
export * from "./park-holiday-rule2.vue?vue&type=script&lang=js&"
import style0 from "./park-holiday-rule2.vue?vue&type=style&index=0&id=6357c5ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357c5ff",
  null
  
)

export default component.exports